import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { map } from 'rxjs';
import { SubscriptionService } from 'src/app/services/kampanje.service';
import { ConfigService } from 'src/app/shared/config';

@Component({
  selector: 'app-menu-copy-dialog',
  templateUrl: './menu-copy-dialog.component.html',
  styleUrl: './menu-copy-dialog.component.css'
})
export class MenuCopyDialogComponent {
  subscriptionForm: FormGroup;
  isEditMode
  @ViewChild('mySelect') mySelect;



  weeks: number[] = Array.from({ length: 53 }, (_, i) => i + 1); // Generate weeks from 1 to 52
  thisYear: number = moment().year(); // Get the current year
  thisWeek: number = moment().week(); // Get the current week
  years: number[] = Array.from({ length: 10 }, (_, i) => this.thisYear + i); // Generate years from current year to next 9 years


  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MenuCopyDialogComponent>
  ) {
    this.subscriptionForm = this.fb.group({
      type: ['amountsAndProducts', Validators.required],
      week: [this.thisWeek, Validators.required],
      year: [this.thisYear, Validators.required],
      fromMonday: [false],
      fromTuesday: [false],
      fromWednsday: [false],
      fromTursday: [false],
      fromFriday: [false],

      toMonday: [false],
      toTuesday: [false],
      toWednsday: [false],
      toTursday: [false],
      toFriday: [false],
      oneToManyDays: [0],
    });
  }

  ngOnInit(): void {

  }

  getType() {
    return this.subscriptionForm.get('type').value;
  }

  onSubmit() {
    if (this.subscriptionForm.valid) {

      const formValue = this.subscriptionForm.value;
      formValue.fromDays = [
        formValue.fromMonday,
        formValue.fromTuesday,
        formValue.fromWednsday,
        formValue.fromTursday,
        formValue.fromFriday
      ];

      formValue.toDays = [
        formValue.toMonday,
        formValue.toTuesday,
        formValue.toWednsday,
        formValue.toTursday,
        formValue.toFriday
      ];

      // Remove the boolean properties from the form value
      delete formValue.fromMonday;
      delete formValue.fromTuesday;
      delete formValue.fromWednsday;
      delete formValue.fromTursday;
      delete formValue.fromFriday;

      delete formValue.toMonday;
      delete formValue.toTuesday;
      delete formValue.toWednsday;
      delete formValue.toTursday;
      delete formValue.toFriday;


      this.dialogRef.close(formValue);
    }
  }
}
